import { render, staticRenderFns } from "./GroupSiteWPModal.vue?vue&type=template&id=6a0b781e&"
import script from "./GroupSiteWPModal.vue?vue&type=script&lang=js&"
export * from "./GroupSiteWPModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupSiteWPModal.vue?vue&type=style&index=0&id=6a0b781e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports